import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const TopTitleBar = ({ enterpriseData, user_name }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  const [darkMode, setDarkMode] = useState(
    localStorage.getItem("darkMode") === "true",
  );

  useEffect(() => {
    document.documentElement.setAttribute(
      "data-theme",
      darkMode ? "dark" : "light",
    );
  }, [darkMode]);

  const toggleDarkMode = () => {
    setDarkMode((prev) => {
      const newMode = !prev;
      localStorage.setItem("darkMode", newMode);
      return newMode;
    });
  };

  const finalEnterpriseData = enterpriseData || {
    enterprise_id: sessionStorage.getItem("enterprise_id"),
    enterprise_name: sessionStorage.getItem("enterprise_name"),
  };

  return (
    <div className="d-flex justify-content-between align-items-center mt-2">
      {/* Left Title Section */}
      <div className="d-flex align-items-center gap-2">
        <span
          className="fw-bold refresh-prompts ak-text-lg"
          style={{
            cursor: "pointer",
            color:
              currentPath === "/conversation-management"
                ? "#909090"
                : "var(--dark-color)",
          }}
          onClick={() => {
            sessionStorage.removeItem("enterprise_id");
            sessionStorage.removeItem("enterprise_name");
            navigate("/superadmin/conversation-management");
          }}
        >
          Conversation Management Details
        </span>

        {finalEnterpriseData?.enterprise_name && (
          <>
            <span className="fw-bold refresh-prompts ak-text-lg">/</span>
            <span
              className="fw-bold refresh-prompts ak-text-lg"
              style={{
                cursor: "pointer",
                color:
                  currentPath === "/superadmin/chat-usage-management"
                    ? "#909090"
                    : "var(--dark-color)",
              }}
              onClick={() =>
                navigate("/superadmin/chat-usage-management", {
                  state: { enterprise: finalEnterpriseData },
                })
              }
            >
              {finalEnterpriseData.enterprise_name}
            </span>
          </>
        )}

        {user_name && (
          <>
            <span className="fw-bold refresh-prompts ak-text-lg">/</span>
            <span
              className="fw-bold refresh-prompts ak-text-lg"
              style={{
                color:
                  currentPath === "/superadmin/user-session-management"
                    ? "#909090"
                    : "var(--dark-color)",
              }}
            >
              {user_name}
            </span>
          </>
        )}
      </div>
    </div>
  );
};

export default TopTitleBar;
